export default [
  {
    title: "Home",
    route: "home",
    icon: "HomeIcon",
    user_types: [],
  },
];
